
import {type Controller} from "../controller";
import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../../global/GlobalEventnames";
import globalsObject from "../globalsObject";
import {arrayElementByKeyValue} from "../../global/arrayHelper";




export type BedruckungsFeaturedObject = {
    foName:string;
    featureWennVeredelt:string;
    featureWennNichtVeredelt:string;
    forPartname:string;
}


export class AutomaticFeatureChanger extends EventListener{
    private fos: BedruckungsFeaturedObject[];
    private controller: Controller;


    public constructor(controller:Controller, fos:BedruckungsFeaturedObject[]) {
        super();
        this.controller = controller;
        this.fos = fos.map((fo) => ({
            ...fo,
            forPartname: (fo.forPartname ?? "").replace(/\s+/g, ""),
        }));
        this.initEventListeners();
        globalsObject.resourceManager.createTask("checkBedruckungsFeatures")
            .discardAfterExecution()
            .when("designtexturesLoaded", "done")
            .thenDo(()=>this.designtexturesLoaded());
    }

    private initEventListeners() {
        this.addEventListener(SELOBEVENTNAMES.INSERTED, (data)=>this.sendbedruckungsFeature(data.selOb.partName))
            .addEventListener(SELOBEVENTNAMES.DELETED, (data)=>this.sendbedruckungsFeature(data.fromPart))
            .addEventListener("designtexturesLoaded", ()=>this.designtexturesLoaded())
            .addEventListener("loadDesignEvent", ()=>this.designtexturesLoaded())
    }

    private sendbedruckungsFeature(partname) {
        const fo = this.fos.filter(featuredObject=>featuredObject.forPartname === partname).shift() as BedruckungsFeaturedObject;
        if(typeof(fo) === "undefined") {
            return;
        }

        let feature;
        if(this.controller.selObController.parthasSelObs(partname))
        {
            feature = fo.featureWennVeredelt;
        }
        else{
            // Mai 2022: das ist jetzt noch bewusst hier, wir testen mal ob unsere google Conversions besser werden wenn wir Pure zunächst one Aufpreise anzeigen
            // sobald wir natürlich ein von Simple abweichendes Design haben, haben wir automatisch einen Aufdruck
            feature = (
                arrayElementByKeyValue(
                    this.controller.model.getCurrentOwayoProduct().possibleDesigns,
                    "Design",
                    this.controller.model.entwurf.getDesign()
                )
                    .Realdesign !== "Simple" && partname.includes("Front")) ? fo.featureWennVeredelt : fo.featureWennNichtVeredelt;
        }

        EventVerteiler.broadcast("featureChangeEvent",
            {
                foName:fo.foName,
                feature:feature  //this.controller.selObController.parthasSelObs(partname) ? fo.featureWennVeredelt : fo.featureWennNichtVeredelt;
            }
        );
    }

    public designtexturesLoaded() {
        this.fos.forEach(fo=>this.sendbedruckungsFeature(fo.forPartname));
    }
}
